import styled from 'styled-components';
import { Close } from 'ui/lexus/outlines';

export default {
    CloseIcon: styled.span`
        width: 18px;
        height: 18px;
        background-image: url(${Close});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    `,
};
